import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAllPosts } from '../blog/posts';
import { formatPostDate } from './BlogPost';
import { useSeo } from '../seo/useSeo';
import SEO_PAGES from '../seo/pages.json';

const BlogIndex = () => {
  const posts = getAllPosts();

  useSeo({ ...SEO_PAGES['/blog'], canonicalPath: '/blog' });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="blog-page">
      <header className="blog-header">
        <p className="offering-feature-eyebrow">The Disco Duck Blog</p>
        <h1>Event Planning Ideas</h1>
        <p className="blog-header-intro">
          Practical guides for planning Kansas City weddings, parties and company events.
        </p>
      </header>

      <main className="blog-list" aria-label="Blog posts">
        {posts.map((post) => (
          <article key={post.slug} className="blog-card">
            <Link className="blog-card-link" to={`/blog/${post.slug}`}>
              {post.image && (
                <div className="blog-card-media">
                  <img src={post.image} alt="" loading="lazy" decoding="async" width="1600" height="1067" />
                </div>
              )}
              <div className="blog-card-body">
                <p className="blog-card-kicker">{post.category}</p>
                <h2 className="blog-card-title">{post.title}</h2>
                <p className="blog-card-description">{post.description}</p>
                <p className="blog-card-footer">
                  <time dateTime={post.publishedAt}>{formatPostDate(post.publishedAt)}</time>
                  <span className="blog-card-readmore">Read the guide &rarr;</span>
                </p>
              </div>
            </Link>
          </article>
        ))}
      </main>
    </div>
  );
};

export default BlogIndex;
